import {
  leaderboardResponseSchema,
  resultDetailSchema,
  type LeaderboardResponse,
  type ResultDetail,
} from '../../shared/api';
import type { LeaderboardBoard } from '../../shared/modes';
import { API_PATHS, resultApiPath } from '../../shared/routes';
import { fetchJson } from './http';

export const PAGE_SIZE = 20;

interface PageRequest {
  offset: number;
  signal?: AbortSignal;
}

export function readArchivedResult(
  roundId: string,
  credential: string,
  signal?: AbortSignal,
): Promise<ResultDetail> {
  return fetchJson(resultDetailSchema, resultApiPath(roundId), {
    credential,
    failure: 'Result unavailable for this profile.',
    ...(signal ? { signal } : {}),
  });
}

export function readLeaderboardPage(
  board: LeaderboardBoard,
  { offset, signal }: PageRequest,
  credential?: string | null,
): Promise<LeaderboardResponse> {
  return fetchJson(
    leaderboardResponseSchema,
    `${API_PATHS.leaderboard}?board=${board}&limit=${PAGE_SIZE}&offset=${offset}`,
    {
      credential: credential ?? null,
      failure: 'Leaderboard unavailable. Try again.',
      ...(signal ? { signal } : {}),
    },
  );
}
